export class Base {

    public getTypeOf(val) {
        return typeof val;
    }     
}